<ng-template #tooltipContent>
    <div class="PGConfirmAction" (mouseenter)="keepOpen(t)" (mouseleave)="closeWithDelay(t)">
        <div class="PGConfirmAction-Title">{{ 'pg-confirm-action.confirm' | locTranslate }}</div>
        @if (action != null) {
            <div class="PGConfirmAction-Text" [innerHTML]="action"></div>
        }
        <div class="PGConfirmAction-Buttons">
            <button type="button" class="btn btn-sm btn-primary" (click)="confirmed.emit(); t.close();"
                [attr.aria-label]="'pg-confirm-action.a11y.confirm' | locTranslate">
                <i class="fa-regular fa-check" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="t.close();"
                [attr.aria-label]="'pg-confirm-action.a11y.cancel' | locTranslate">
                <i class="fa-regular fa-times" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</ng-template>
<span [ngbTooltip]="tooltipContent" triggers="manual" #t="ngbTooltip" (mouseup)="stopEvent($event);" (click)="stopEvent($event); keepOpen(t);" (keydown.enter)="stopEvent($event); keepOpen(t);" (keydown.space)="stopEvent($event); keepOpen(t);" (mouseleave)="closeWithDelay(t)" [container]="tooltipContainer">
    <ng-content></ng-content>
</span>
